/**
 * @generated SignedSource<<887664e330e1b4fd4c01ef9ff67acf37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vendorPayoutId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedBy",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedTime",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PayoutUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVendorPayoutTPayload",
        "kind": "LinkedField",
        "name": "updateVendorPayoutTByVendorPayoutId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VendorPayoutT",
            "kind": "LinkedField",
            "name": "vendorPayoutT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PayoutUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVendorPayoutTPayload",
        "kind": "LinkedField",
        "name": "updateVendorPayoutTByVendorPayoutId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VendorPayoutT",
            "kind": "LinkedField",
            "name": "vendorPayoutT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a78f59847d851b37f764ba9c114b2400",
    "id": null,
    "metadata": {},
    "name": "PayoutUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PayoutUpdateMutation(\n  $input: UpdateVendorPayoutTByVendorPayoutIdInput!\n) {\n  updateVendorPayoutTByVendorPayoutId(input: $input) {\n    vendorPayoutT {\n      vendorPayoutId\n      approvedBy\n      approvedTime\n      status\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "916582433fcd9e40ba9d171c687d7640";

module.exports = node;
